// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inline {
  flex-flow: row nowrap;
  padding: 0 5%;
  width: 100%;
  justify-content: center;
}
@media (min-width: 576px) {
  .form-inline .form-control {
    min-width: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/text-input/text-input.component.less"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AADJ;AAGA;EACI;IACI,cAAA;EADN;AACF","sourcesContent":["@import (reference) \"../../../styles.less\";\n\n.form-inline {\n    flex-flow: row nowrap;\n    padding: 0 5%;\n    width: 100%;\n    justify-content: center;\n}\n@media (min-width: 576px) {\n    .form-inline .form-control {\n        min-width: 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
